import { ActivatedRoute, Router } from "@angular/router";
import { BaseAccountService } from "admin/baseLogin/BaseAccountService";
import { AppConstants } from "admin/utile/AppConstants";
import { RouterUtils } from "admin/_global/GlobalUtils";

export class BaseLogin
{
    isLogingIn: boolean = false;
    error: string;

    constructor(
        protected accountService: BaseAccountService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected accountUrl: string)
    {
    }

    login(email: string, password: string): void {
        this.isLogingIn = true;

        this.accountService.login(email, password).subscribe(
            result => {
                if (!result.Success) {
                    if (result.Error) {
                        this.error = result.Error;
                    }

                    this.isLogingIn = false;

                    return;
                }

                this.router.dispose();

                const code: string = RouterUtils.GetParamByName(this.route, "code");

                if (code) {
                    window.location.reload();
                }
                else {
                    window.location.replace(AppConstants.baseUrl + this.accountUrl);
                }
            },
            error => {
                this.isLogingIn = false;
            }
        );
    }

    goToForgetPassword(): void {
        const code: string = RouterUtils.GetParamByName(this.route, "code");
        if (code) {
            this.router.navigate(['/forgot-pass/company-join/' + code]);
        }
        else {
            this.router.navigate(['/forgot-pass']);
        }
    }

    goToRegister(): void {
        const code: string = RouterUtils.GetParamByName(this.route, "code");
        if (code) {
            this.router.navigate(['/register/company-join/' + code]);
        }
        else {
            this.router.navigate(['/register']);
        }
    }
}